import React, { useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleRight, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import Item from '../Item';
import { Link } from "react-router-dom";

const Deliverable = styled.div`
                            h2{
                              
                                font-size: 18px;
                                color: #000;
                                text-align: center;
                                padding-top: 8px;
                                font-weight: bold;
                                
                            }
                            h3{
                                font-size: 16px;
                                color: #000;
                                text-align: center;
                                font-weight: normal;
                                
                            }
							@media (max-width: 991px) {
								padding-top:100px;
								.mobile-title{
									text-align:center;
									margin-bottom:6px;
								}
							}
							.category-outer{
								background: #F5F5F5;
								padding: 20px 40px;
								margin: 20px auto;
							}
							.cat-border{
								border-top:solid 1px #dfdfdf;
                                padding-top:15px;
                                margin-top:15px;
								@media (max-width: 991px) {
									border-top:0px;
								}
							}
							.dept-title{
								color:#000;
                                font-size:14px;
                                font-weight:bold;
							}

							.activity-filter{
								margin:auto;
								width:200px;
								padding-bottom:15px;
								line-height:35px;
								span{
									padding-right:5px;
								}
                            }
                            .icon{
                                display:block;
                                color:#999;
                                position:absolute;
                                font-size:18px;
                                top:0px;
                                right:60px;
                                @media (max-width: 1299px) {
                                    top:60px;
                                    right: 50%;
								}

                            }
                            .mobile-title{
                                position:relative;
                            }

							
							
`;

const DeliverableMain = (props) => {

    const deliverables = useSelector(state => state.deliverables);

    return (

        <Deliverable>
            <div className="container">
                <div className="category-outer">
                    <section>
                        <div className="row">
                            <div className="col-12 align-center">
                                <h2>Department Deliverables</h2>
                                <h3>The core responsibilities of each business area</h3>
                            </div>
                        </div>
                    </section>
                    {props.departments ? props.departments.map((dept, index) => (
                        deliverables.filter(deliverable => deliverable.dept === dept.slug).length !== 0 ?
                            <section key={index}>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="cat-border"></div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 col-md-2 mobile-title">
                                        <Link to={`/categories/${dept.slug}`}>
                                            <span className="dept-title">{dept.name}</span>
                                            <span className="icon">
                                                <FontAwesomeIcon icon={faArrowCircleRight} />
                                            </span>
                                        </Link>
                                    </div>
                                    <div className="col-sm-12 col-md-8 px-0">
                                        <div className="row">
                                            <div className="col-12 px-0">
                                                <div className="row">
                                                    {deliverables.filter(deliverable => deliverable.dept === dept.slug).map((item, index) => (
                                                        <div className="col-sm-12 col-md-3 px-2" key={index}>
                                                            <Item item={item} deliverable={true} />
                                                        </div>
                                                    )
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-2">

                                    </div>
                                </div>
                            </section>
                            : ''
                    )
                    ) : ''}
                </div>
            </div>
        </Deliverable>

    );
}

export default DeliverableMain;